import React from "react";
import { StyleSheet, View } from "react-native";
import { Appbar, Text } from "react-native-paper";
import { useTranslation } from "react-i18next";

interface FileDetailsEmptyStateProps {
  onBack: () => void;
}

export default function FileDetailsEmptyState({
  onBack,
}: FileDetailsEmptyStateProps) {
  const { t } = useTranslation();

  return (
    <View style={styles.container}>
      <Appbar.Header>
        <Appbar.BackAction onPress={onBack} />
        <Appbar.Content title={t("File Details")} />
      </Appbar.Header>

      <View style={styles.emptyState}>
        <Text variant="titleMedium">{t("File not found")}</Text>
        <Text variant="bodyMedium" style={styles.emptyStateText}>
          {t("This file is no longer available.")}
        </Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  emptyState: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 24,
  },
  emptyStateText: {
    marginTop: 8,
    opacity: 0.6,
    textAlign: "center",
  },
});
